<template>
     <div>
        <div class="container mt-4 mb-4">
            <!-- <atras-component></atras-component> -->
            <boton-atras :nombre_ruta="'municipal'"></boton-atras>
            <div class="row">
                <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                    <h6 class="subtitulo mb-2">Ley de Ingreso Municipal</h6>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <div class="card mt-4">
                        <div class="card-body pt-1">
                            <div class="row card-body">
                                <div class="container mb-3">
                                    <p class="subtitulo2">Seleccione el municipio a consultar</p>
                                </div>
                                <div class="col-7">
                                    <!-- AREA DEL SELECT -->
                                    <select class="js-example-basic-single" id="miCombo" >
                                        <option>Cargando...</option>
                                    </select>  
                                </div>
                                <div class="col-5">
                                    <button @click="consulta" class="btn btn-vino btn-block">Consultar</button>
                                </div>       
                            </div>
                        </div>
                    </div>
                    <div v-if="verDocumentos" class="mt-5">
                        <spiner v-show="loading && verDocumentos"></spiner>
                        <h6 v-show="loading && verDocumentos" class="text-center text-muted mb-5"> Cargando contenido...</h6>
                        <h4>{{data2.Desc_Municipio}}</h4> 
                        <div v-for="(dato, indice) in data2.Documentos" :key="indice">                               
                            <a :href="rutaConsulta(urlServe, dato.Datos_Ruta, dato.URL_Documento)" target="_blank">
                                <div class="mb-2">
                                    <div class="title_document" style="display:flex; justify-content:space-between;">
                                        <div class="col-9">
                                             <h5> {{ dato.Ano }} </h5>
                                        </div>
                                        <div class="col-4">
                                            <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                        </div>
                                    </div> 
                                </div>
                            </a> 
                        </div>
                        
                        
                    </div>
                   
                                           
                   
                     <!-- <code>{{data2}}</code> -->
                    
                    
                </div>                
                <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                    <div class="row margenes">
                        <div class="sec_imagen"> 
                            <img src="@/assets/imagenes/leyIngresoMunicipal.jpg" alt="">  
                        </div>
                    </div>                   
                </div>
            </div>
            <div class="text-aviso my-5">
                <h5> <span class="resaltado-vino">AVISO:</span> Los instrumentos jurídicos que se mencionan a continuación, son solo de referencia, encontrándose para su consulta oficial en el portal de internet de la <u><a href="https://www.sgg.chiapas.gob.mx/" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, o en su caso en la versión impresa en el órgano de difusión oficial.</h5>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import atrasComponent from './../../reload.vue'
    import spiner from './../../spiner.vue'
    import botonAtras from './../../button-atras'
    export default {
        data: function(){
            return{
                municipio: '',
                archivosMunicipios: '',
                data: null,             
                jsonMunicipios: this.$urlServiciosHacienda + 'Municipio/ObtenerMunicipioListado',  
                data2: null,
                jsonMunicipiosArchivos: this.$urlServiciosHacienda + 'Municipio/ObtenerDocumentos/',
                jsonMunicipiosArchivosDefault: this.$urlServiciosHacienda + 'Municipio/ObtenerDocumentos/1',
                verDocumentos: false,
                loading: true, 
        
            }
        },
        components:{
            atrasComponent,
            spiner,
            botonAtras
        },
        watch:{

        },
        methods:{
            proceso(_combo){
                const UrlServer = this.jsonMunicipios;
                $.get(UrlServer, function (data) {
                    $("#" + _combo).empty();
                    $.each(data.data, function (indice, row) {            
                            // $("#" + _combo).append("<option value='" + row.id + "'>" + row.nombre + "</option>");
                            $("#" + _combo).append("<option value='" + row.Cve_Municipio + "'>" + row.Desc_Municipio + "</option>");
                            // this.data = row.datos[0].ano;
                        });
                        $("#" + _combo).select2();
                    })
                    .fail(function (result) {
                        console.log("Ocurrio un error, intente de nuevo. " + result.responseText);
                    });
            },

            consulta(){
                this.verDocumentos = true;
                var urlmunicipioSeleccionado = "";
                this.municipio = document.getElementById('miCombo').value;
                this.archivosMunicipios =   this.jsonMunicipiosArchivos + this.municipio; 
                urlmunicipioSeleccionado = this.archivosMunicipios;
                // console.log(urlmunicipioSeleccionado)
                // AQUI
                axios.get(urlmunicipioSeleccionado)
                .then(response => {
                    this.data2 = response.data.data
                    console.log(this.data2)
                })
                // console.log("esto!!!" + this.data2.data);
                

                
            },
            rutaConsulta(urlServe, ruta, url){
                //rutaConsulta(urlServe, dato.ruta, dato.url)
                var respuesta;
                if(ruta == 0){
                    respuesta = urlServe + url;
                }else{
                    respuesta = url;
                }
                return respuesta;
            }
        },
        created: function(){
            $('.js-example-basic-single').select2();
            this.proceso('miCombo');
        },
        mounted () {
            window.scrollTo(0, 0);
            /* llena la variable data con el json de los municipios */
            axios
            .get(this.jsonMunicipios)
            .then(response => (this.data = response.data))
            axios
            .get(this.jsonMunicipiosArchivosDefault)
            .then((res) => {
                this.data2 = res.data              
                this.loading = false
            })
            // .then(response => (this.data2 = response.data))
        },
    }
</script>
<style scoped>
    .title_document { 
        padding: .8rem 1rem;             
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    } 

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    }
    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    }
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 20px;
    }

    .sec_imagen{ 
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .card-width{ width: 90%; }
    
    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }
    .leyendaSeleccionar{
        font-size: 21px;
        font-weight: 300;
        margin-bottom: .5rem;
        /* margin-top: 1rem; */
    }

    /* ///ESTILOS PARA EL SELECT 2 */
    /* .selectMunicipios{
        margin-top: 2rem;
    } */
    .select2-container--default .select2-selection--single {  /****CHECAR PORQUE NO ME TOMA ESTOS ESTILOS EN EL SELECT 2******* */
   
        height: 3rem !important;
        padding-top: 8px;
        font-size: 23px;
    }

    #miCombo{
        width: 100%;
        height: 100%;
        border-radius: 5px;
        border: 1px solid #d9d4d4;
        font-size: 18px;
        color: #4e4a4a;
        padding: .5rem;
    }
    select:focus{ outline: none;}
    

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    /* .subtitulo2{ font-size: 1rem; } */

    .sec_imagen{ margin-top: 0rem; }

    a { font-size: 14px; }

    h6 { font-size: 13px; }

    .form-control-lg {  
        padding: .5rem .3rem;
        font-size: 0.9rem;
    }

    .btn{
        padding: .5rem .9rem;
        font-size: .7rem;
    }

    /* propiedades del card de consultar año */
    .card-body{ padding: .8rem; }
    .col-7{
        padding-right: 5px !important;
        padding-left: 5px !important;
    }
    .col-5{
        padding-right: 5px !important;
        padding-left: 5px !important;
    }

    .sec_imagen { margin-left: 0 !important; }

    .subtitulo2{ font-size: 15px !important; }
    button{ font-size: .9rem !important; }
}

</style>